import { render, staticRenderFns } from "./BindsCardMediaActions.vue?vue&type=template&id=9af18486&"
import script from "./BindsCardMediaActions.vue?vue&type=script&lang=js&"
export * from "./BindsCardMediaActions.vue?vue&type=script&lang=js&"
import style0 from "./BindsCardMediaActions.vue?vue&type=style&index=0&id=9af18486&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports